import angular from 'angular';

export default angular.module('falsyToDashes', [])
.filter('falsyToDashes', function () {
    return function(input) {
        return !input || input === '0' ? '--' : input;
    };
}).name;